import Swal from "sweetalert2"

export const ListResourceMixin = {
    data: () => ({
        busy: true,
        records: [],
        filter: "",
        page: 1,
        total: 1,
        totalPage: 1,
        perPage: 10,
        actualPage: 1
    }),

    methods: {

        async $loadResource({
            size = 10,
            page,
            filter,
            isOrOperation = "",
            params = {},
        }) {
            if (!this.$service) {
                throw new Error("t  his.$service cannot be null");
            }


            if (this.actualPage == page) {
                this.page = 1
                page = 1
            }
            this.actualPage = page;
            this.isBusy = true;
            const { data, ...rest } = await this.$service.findAll({
                size,
                page,
                filter,
                isOrOperation,
                params,
            });

            if (rest.response && rest.response.data.status === 403) {
                return rest;
            } else if (rest.response && rest.response.data.status === 404) {
                return rest;
            } else if (rest.response && rest.response.status === 500) {
                return rest;
            }
            this.records = data.content;
            this.total = data.totalElements || 0;
            this.totalPage = data.totalPages || 0;
            this.page = data.pageable.pageNumber + 1;
            this.busy = false;

            return data;
        },

        async $editResource({ id }) {
            if (!this.$router) {
                throw new Error("this.$router cannot be null");
            }

            this.$router.push({ path: `${id}` });
        },

        async $removeResource({ id }) {
            if (!this.$service) {
                throw new Error("this.$service cannot be null");
            }
            if (!this.$notify) {
                throw new Error("this.$notify cannot be null");
            }

            const value = await Swal.fire({
                title: "Tem certeza que deseja excluir?",
                text: "Esta ação não poderá ser desfeita!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(({ value }) => {
                return value;
            });

            if (!value) {
                return;
            }

            this.$service.remove(id).then(() => {
                this.load();
                this.$notify({
                    type: "success",
                    message: "Registro excluído com sucesso!",
                });

            }).catch(err => {
                this.$notify({
                    type: "danger",
                    title: "Erro ao excluir o registro!",
                    message:
                        err.response.data,
                });
            });
        },
    },
};

export const FormResourceMixin = {
    computed: {
        formIsValid() {
            return !this.$v.$invalid;
        },
    },
    methods: {
        async $saveResource(
            record,
            to = "",
            validate = true,
            roteParams = {},
            isModal = false,
            mostrarErro = false,
        ) {
            if (!this.$service) {
                throw new Error("this.$service cannot be null");
            }
            if (!this.$notify) {
                throw new Error("this.$notify cannot be null");
            }

            const $success = (message) => {
                this.$notify({ type: "success", message });
            };
            const $danger = (message) => {
                this.$notify({ type: "danger", message });
            };

            if (validate && !this.formIsValid) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                });

                return;
            }

            if (this.$saving) {
                return;
            }
            this.$saving = true;

            try {
                const response = await this.$service.save(record);
                $success("Registro salvo com sucesso!");
                if (isModal) {
                    return response;
                }
                if (to != null && to != "")
                    this.$router.push({ name: to, params: roteParams });
            } catch ({ response }) {
                const { data } = response;
                if (!data.errors) {
                    $danger(mostrarErro ? data : "Erro ao salvar o registro.");
                    throw "Erro ao salvar o registro.";
                }

                data.errors.forEach((error) => {
                    $danger(error.message);
                });
            } finally {
                this.$saving = false;
            }
        },
        async $saveResourceFormData(
            id = null,
            record,
            to = "",
            validate = true,
            roteParams = {},
            isModal = false,
            mostrarErro = false,
        ) {
            if (!this.$service) {
                throw new Error("this.$service cannot be null");
            }
            if (!this.$notify) {
                throw new Error("this.$notify cannot be null");
            }

            const $success = (message) => {
                this.$notify({ type: "success", message });
            };
            const $danger = (message) => {
                this.$notify({ type: "danger", message });
            };

            if (validate && !this.formIsValid) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                });

                return;
            }

            if (this.$saving) {
                return;
            }
            this.$saving = true;

            try {
                const response = await this.$service.saveFormData(id, record);
                $success("Registro salvo com sucesso!");
                if (isModal) {
                    return response;
                }
                if (to != null && to != "")
                    this.$router.push({ name: to, params: roteParams });
            } catch ({ response }) {
                const { data } = response;
                if (!data.errors) {
                    $danger(mostrarErro ? data : "Erro ao salvar o registro.");
                    throw "Erro ao salvar o registro.";
                }

                data.errors.forEach((error) => {
                    $danger(error.message);
                });
            } finally {
                this.$saving = false;
            }
        },
        async $saveForm(
            record
        ) {
            if (!this.$service) {
                throw new Error("this.$service cannot be null");
            }
            if (!this.$notify) {
                throw new Error("this.$notify cannot be null");
            }


            return this.$service.saveForm(record);
        },
    },
};

export default { ListResourceMixin, FormResourceMixin };
